import { z } from 'zod';

export const OneDriveSyncJobSchema = z.object({
  recordingId: z.string(),
  userId: z.string(),
  syncType: z.enum(['transcript', 'report', 'both']),
});

export type OneDriveSyncJob = z.infer<typeof OneDriveSyncJobSchema>;

export const OneDriveMoveJobSchema = z.object({
  recordingId: z.string(),
  userId: z.string(),
  oldFolderName: z.string().nullable(),
  newFolderName: z.string().nullable(),
});

export type OneDriveMoveJob = z.infer<typeof OneDriveMoveJobSchema>;
